import { Theme, css } from '@emotion/react'

export const form = (theme: Theme) => css`
  display: flex;
  flex-direction: column;
  row-gap: ${theme.spacing(3)};
`
